import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoadingContainer from 'components/common/LoadingContainer';
import DonarFormContainer from 'components/donor/donor-form/DonorFormContainer';
import { useDonor, useUpdateDonor } from 'hooks/useDonors';

/* -------------------------------------------------------------------------- */
const EditDonor = () => {
  const navigate = useNavigate();
  const { donorId: id } = useParams();

  const { donor, isLoading: dataLoading } = useDonor(id);
  const { updateDonorAsync, isUpdating } = useUpdateDonor();

  const handleUpdate = async data => {
    try {
      await updateDonorAsync({
        id,
        data
      });
      navigate(-1);
      toast.success('Donor updated successfully');
    } catch (error) {
      toast.error('Something went wrong! Please try again');
      console.error(error);
    }
  };

  return dataLoading ? (
    <LoadingContainer />
  ) : (
    <DonarFormContainer
      loading={isUpdating}
      onSubmit={handleUpdate}
      data={donor}
      isEdit
    />
  );
};

export default EditDonor;
